<template lang="pug">
  modal.modal(@closeModal='hideModal')
    form.column.center.m-top-3(@submit.prevent='submit')
      p.text-big.m-bottom-1.text-center {{ $t("krea.suggestTopicModal.description") }}
      h3.title-medium {{ $t("krea.suggestTopicModal.title") }}
      .column.self-start.width-100.m-top-4
        label.text-normal.bold {{ $t("krea.suggestTopicModal.label") }}
        input.input-base.input-border.text-normal.width-100(v-model='newTopic')
      span.text-normal.m-bottom-5.m-top-3 {{ $t("krea.suggestTopicModal.thanks") }}
      button.primary-button.max-width-none.width-100(type="submit")
        | {{ $t("krea.suggestTopicModal.send") }}
</template>

<script>
import Modal from '@/components/Modal'
import { mapActions } from 'vuex'

export default {
  components: { Modal },
  data() {
    return {
      newTopic: ''
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'suggestNewTopic'
    ]),
    hideModal() {
      this.hideElement({ element: 'suggestTopicModal' })
    },
    async submit() {
      if (!this.newTopic) return
      await this.suggestNewTopic(this.newTopic)
      this.hideModal()
    }
  }
}
</script>

<style lang="scss" scoped>

.modal{
  --max-width: 464px;
  max-width: none;
}
</style>
